module.exports = __webpack_public_path__ + "static/media/AcceptButton.c3b388eb.svg";